/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';

import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { Handover } from 'events/_types';

export interface UseHandoverParams {
  startAt?: string;
  endAt?: string;
  departmentId?: string;
  enabled?: boolean;
}

export function useHandover({
  startAt,
  endAt,
  departmentId,
  enabled = true,
}: UseHandoverParams = {}) {
  const params = new URLSearchParams();
  if (startAt) params.set('start_at', startAt);
  if (endAt) params.set('end_at', endAt);
  if (departmentId) params.set('department', departmentId);
  const queryString = params.toString();
  const url = queryString
    ? `${apiRoutes.handover()}?${queryString}`
    : apiRoutes.handover();

  return useQuery<Handover>({
    queryKey: [
      APIKey.HANDOVER,
      startAt ?? null,
      endAt ?? null,
      departmentId ?? null,
    ],
    queryFn: () => baseFetcher(url),
    enabled,
  });
}
